import axios from "axios";

const API_URL = (process.env.NODE_ENV != 'production' ? "https://api.milfhub.co.uk/" : "https://api.milfhub.co.uk/");

const register = (username, email, password) => {
  return axios.post(API_URL + "api/users/register", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(API_URL + "api/admin/signin", {
      email:username,
      password,
    })
    .then((response) => {
      if (response.data.data.token) {
        localStorage.setItem("token", JSON.stringify(response.data.data.token));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("token");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("D_User"));
};
const getCurrentUserTokken = () => {
  return JSON.parse(localStorage.getItem("token"));
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  getCurrentUserTokken
}

export default AuthService;
